<div
  [@shell]
  *ngIf="
    (isShellOpenOrMinimized$ | async) &&
    (enableNewPreChatWelcome$ | async) === false
  "
  class="shell"
  [ngClass]="{
    'shell-minimized': isShellMinimized$ | async
  }"
>
  <div class="shell-container">
    <cigna-omni-shell-header></cigna-omni-shell-header>

    <div class="router" [@flyInOut]="animationState$ | async">
      <ng-container
        *ngComponentOutlet="currentComponent$ | async"
      ></ng-container>
    </div>
  </div>
</div>

<div
  [@shell]
  *ngIf="
    (isShellOpenOrMinimized$ | async) &&
    !shouldHideHeader &&
    (enableNewPreChatWelcome$ | async)
  "
  class="shell new-box"
  [ngClass]="{
    'shell-minimized': isShellMinimized$ | async
  }"
>
  <div
    class="shell-container"
    *ngIf="{
      canUpdateAnalyticsData: canUpdateAnalyticsData$ | async
    } as data"
  >
    <cigna-omni-shell-header
      *ngIf="(shouldEnablePreChatWelcome$ | async) === false"
    ></cigna-omni-shell-header>
    <cigna-omni-shell-prechat-header
      [isHistory]="isShowHistory$ | async"
      [existingConvId]="existingConvId | async"
      [shouldCloseSplashScreen]="closeSplashScreen$ | async"
      [shouldFocusOnHeader]="shouldFocusOnHeader$ | async"
      [isDcmChat]="isDcmChat$ | async"
      (printEmitter)="printTranscript(data.canUpdateAnalyticsData)"
      *ngIf="shouldEnablePreChatWelcome$ | async"
    ></cigna-omni-shell-prechat-header>
    <div class="router" [@flyInOut]="animationState$ | async">
      <ng-container
        *ngComponentOutlet="currentComponent$ | async"
      ></ng-container>
    </div>
  </div>
</div>
